exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-enter-active{transition:all .5s ease}.slide-enter{transform:translateX(100%)}.content{white-space:pre-line}.display-1.title-text{font-size:26px!important}.detail-img:hover{cursor:zoom-in}.detail-section{padding:30px}.detail-section .related-products-title{font-size:26px}.detail-section .related-products-subtitle{font-size:20px;margin-top:15px;margin-bottom:0}@media (max-width:599px){.detail-section{padding-left:0;padding-right:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b13e4e2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Detail.vue
// module id = 545
// module chunks = 0